/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('PhysicalResourceCtrl', ["$scope", "$rootScope", "$dialog", "$timeout", "$filter", "DateSrv", "PhysicalResourceSrv", "PhysicalResourceData",
    "PhysicalResource", "SiteData", "PhysicalResourceView", "LanguageManager",
    function ($scope, $rootScope, $dialog, $timeout, $filter,
              DateSrv, PhysicalResourceSrv, PhysicalResourceData, PhysicalResource, SiteData, PhysicalResourceView, LanguageManager) {

//PhysicalResource functions
        $scope.dd =
            {
                view:
                    {
                        physicalResourcesView: [],//for planning TODO RENAME
                        physicalResourcesActiveView: [],//Active pr
                        physicalResourcesDeletedView: [],
                        physicalResourcesUnitView: [] //visible on planning
                    },
                edited: {prView: null},
                displaySubConf: 1,
                display: {
                    startDay: 0,
                    nbDays: 6
                }
            };

        $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
            if (newValue) {
                if (!$scope.ad.managerMode) {
                    $scope.goToDomain("planningPos", "dashboard");
                }
                var physicalResources = PhysicalResourceData.getActiveList();
                var prView;
                for (var i = 0; i < physicalResources.length; i++) {
                    prView = new PhysicalResourceView(physicalResources[i], PhysicalResourceData.getIndexOf(physicalResources[i]), $scope, physicalResources[i].order);
                    $scope.dd.view.physicalResourcesActiveView.push(prView);
                    $scope.dd.view.physicalResourcesView.push(prView);
                    for (var k = 1; k <= prView.number; k++)
                        $scope.dd.view.physicalResourcesUnitView.push({
                            prView: prView,
                            prUnitId: k,
                            label: prView.label + (prView.number > 1 ? ' ' + k : '')
                        })
                }

                // Sort physicalResourcesActiveView by order value
                if ($scope.dd.view.physicalResourcesActiveView.length > 1)
                    $scope.sortPrActiveViewArray();
                var physicalResourcesDeleted = PhysicalResourceData.getDeletedList();
                for (var i = 0; i < physicalResourcesDeleted.length; i++)
                    $scope.dd.view.physicalResourcesDeletedView.push(new PhysicalResourceView(physicalResourcesDeleted[i], PhysicalResourceData.getIndexOf(physicalResourcesDeleted[i]), $scope));
            }
        });
        $scope.isPrArrayOrdered = function () {
            var physicalResources = PhysicalResourceData.getActiveList();

            physicalResources = $filter('orderBy')(physicalResources, 'order');

            var orderedValues = true;
            for (var i = 0; i < physicalResources.length; i++) {
                if (physicalResources[i].order == null || physicalResources[i].order != i)
                    orderedValues = false;
            }
            return orderedValues;
        };
        $scope.sortPrActiveViewArray = function () {
            $scope.dd.view.physicalResourcesActiveView = $filter('orderBy')($scope.dd.view.physicalResourcesActiveView, 'order');
        };
        $scope.changeOrderDown = function (prView) {
            var index = $scope.dd.view.physicalResourcesActiveView.indexOf(prView);
            // put a physical resource up in the order
            if (index > 0 && index != -1)
                $scope.dd.view.physicalResourcesActiveView[index - 1].order++;
            prView.order--;

            $scope.sortPrActiveViewArray();
        };
        $scope.changeOrderUp = function (prView) {
            // put a physical resource down in the order
            var index = $scope.dd.view.physicalResourcesActiveView.indexOf(prView);
            // put a physical resource up in the order
            if (index < ($scope.dd.view.physicalResourcesActiveView.length - 1) && index != -1)
                $scope.dd.view.physicalResourcesActiveView[index + 1].order--;
            prView.order++;

            $scope.sortPrActiveViewArray();
        };
        $scope.getPhysicalResourcesView = function () {
            return $scope.dd.view.physicalResourcesView;
        }

        $scope.getPrView = function (hr) {
            for (var i = 0; i < this.physicalResourcesActiveView.length; i++)
                if (this.physicalResourcesActiveView[i].getModel() === hr)
                    return this.physicalResourcesActiveView[i];

            for (var i = 0; i < this.physicalResourcesDeletedView.length; i++)
                if (this.physicalResourcesDeletedView[i].getModel() === hr)
                    return this.physicalResourcesDeletedView[i];

            return null;
        }


        $scope.getCfgClass = function (confItem, className) {
            if (confItem == $scope.dd.displaySubConf)
                return className;
            return "";
        }


    }]);



// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/pr/physicalResourceCtrl.js